// Page-range helpers. Behaviour mirrors the mobile app's utils.dart so prices and
// uploaded files are identical whether an order comes from the app or the website.

function toInt(text) {
  const t = String(text).trim();
  if (!/^\d+$/.test(t)) throw new Error("not a number");
  return parseInt(t, 10);
}

/** "1-3,7" -> [1,2,3,7] (insertion order, duplicates removed). Invalid input -> []. */
export function parseNumberString(numberString) {
  const numbers = new Set();
  if (!numberString || !String(numberString).trim()) return [];
  try {
    for (let part of String(numberString).split(",")) {
      part = part.trim();
      if (part.includes("-")) {
        const [a, b] = part.split("-");
        const start = toInt(a);
        const end = toInt(b);
        for (let i = start; i <= end; i++) numbers.add(i);
      } else {
        numbers.add(toInt(part));
      }
    }
  } catch (e) {
    return [];
  }
  return Array.from(numbers);
}

export function hasOverlap(input1, input2) {
  if (!input1 || !input2) return false;
  const a = new Set(parseNumberString(input1));
  if (a.size === 0) return false;
  return parseNumberString(input2).some((n) => a.has(n));
}

/** Removes spaces and a dangling trailing "," or "-" the user may leave behind. */
export function normalizeRange(text) {
  let t = String(text || "").replace(/\s+/g, "");
  while (t.endsWith(",") || t.endsWith("-")) t = t.slice(0, -1);
  return t;
}

/**
 * Returns an error message for an invalid range string, or null when it is valid.
 * Empty strings are considered valid (callers decide whether a value is required).
 */
export function validateRange(text, totalPages) {
  const t = normalizeRange(text);
  if (!t) return null;
  if (!/^\d+(-\d+)?(,\d+(-\d+)?)*$/.test(t)) return "Use page numbers like 1-3, 5, 8";
  for (const part of t.split(",")) {
    if (part.includes("-")) {
      const [a, b] = part.split("-").map((n) => parseInt(n, 10));
      if (b < a) return `Enter a page greater than ${a}`;
      if (a < 1 || b > totalPages) return `Pages must be between 1 and ${totalPages}`;
    } else {
      const n = parseInt(part, 10);
      if (n < 1 || n > totalPages) return `Pages must be between 1 and ${totalPages}`;
    }
  }
  return null;
}

/** [1,2,3,7,8] -> "1-3,7-8" */
export function compressPages(pages) {
  const sorted = Array.from(new Set(pages)).sort((a, b) => a - b);
  const parts = [];
  let i = 0;
  while (i < sorted.length) {
    const start = sorted[i];
    let end = start;
    while (i + 1 < sorted.length && sorted[i + 1] === end + 1) {
      i += 1;
      end = sorted[i];
    }
    parts.push(end > start ? `${start}-${end}` : `${start}`);
    i += 1;
  }
  return parts.join(",");
}
